import { render, staticRenderFns } from "./VerticalNavMenuExternalLink.vue?vue&type=template&id=266b60a8&"
import script from "./VerticalNavMenuExternalLink.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuExternalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports